import { format } from 'date-fns/format';
import { commonItemPropType } from '../../declarations.propTypes';
import ImportSavedListLink from '../ImportSavedListLink';

const ModifiedAndImport = ({ item }) => {
  const { updated } = item;
  return (
    <>
      <div>{`${
        !isNaN(updated) ? format(new Date(updated), 'M/d/yy') : ''
      }`}</div>
      <div className="mt-4">
        <ImportSavedListLink item={item} />
      </div>
    </>
  );
};
export default ModifiedAndImport;

ModifiedAndImport.propTypes = {
  item: commonItemPropType
};
